export default __webpack_public_path__ + "static/media/banner.3071a4b2.jpg";